import { useProtagAnimals } from 'app/agriculture/queries/protagAnimals/useProtagAnimals';
import { Billboard } from 'app/agriculture/FarmMain/MapRenderer/renderers/Billboard';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';

export function ProtagAnimalRenderer() {
    const animals = useProtagAnimals();

    return (
        <>
            {Array.from(animals.keys()).map((id) => (
                <ProtagAnimalBillboard key={id} protagAnimalId={id} />
            ))}
        </>
    );
}

function ProtagAnimalBillboard({ protagAnimalId }: { protagAnimalId: string }) {
    const snapshot = useSnapshot({ snapshotType: 'ProtagAnimal', parentId: protagAnimalId });

    if (!snapshot?.location) return null;

    return (
        <Billboard
            id={protagAnimalId}
            type="ProtagAnimal"
            coordinates={[snapshot.location.longitude, snapshot.location.latitude]}
        />
    );
}
